import React from 'react';
import { Box, ThemeProvider } from '@mui/material';

import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { createHubTheme, getStoredHubMode } from '../theme/hubTheme';


export const HubBodyLoading: React.FC = () => {
  const theme = React.useMemo(() => createHubTheme(getStoredHubMode()), []);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
        <BodyLoading height="100vh"/>
      </Box>
    </ThemeProvider>
  );
};
